var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5716 4.45693C11.0169 3.06734 12.9831 3.06734 13.4284 4.45693L14.3601 7.36404C14.5592 7.98498 15.1365 8.40623 15.7886 8.40623H18.8469C20.295 8.40623 20.9025 10.2552 19.7365 11.114L17.227 12.9624C16.7085 13.3443 16.4916 14.0146 16.6882 14.6279L17.6384 17.5926C18.0824 18.9782 16.4919 20.121 15.3203 19.2581L12.8896 17.4677C12.3605 17.078 11.6395 17.078 11.1104 17.4677L8.67965 19.2581C7.50813 20.121 5.91756 18.9782 6.36164 17.5926L7.3118 14.6279C7.50836 14.0146 7.29149 13.3443 6.77295 12.9624L4.26347 11.114C3.09752 10.2552 3.70496 8.40623 5.15306 8.40623H8.21142C8.86347 8.40623 9.44084 7.98498 9.63985 7.36404L10.5716 4.45693Z",
    fill: "black"
  })));
};

export default SvgStar;